import React from 'react'
import { useSelector } from 'react-redux'
import cx from 'classnames'
import { Form as ReactFinalForm, Field } from 'react-final-form'
import Router from 'next/router'
import { OnChange } from 'react-final-form-listeners'

import { Box } from '@piconetworks/ui'
import Form from '@piconetworks/pkg-form'
import ContentSection from 'components/ContentSection'
import Overflow from 'components/Overflow'
import SubscriptionsList from './SubscriptionsList'
import AccessControl from 'components/AccessControl'

import ProductsModule from 'modules/products'
import { constants, useFeatureManager } from 'features/FeatureManager'

import { INDIVIDUAL_SUBSCRIPTION_TYPE, GROUP_SUBSCRIPTION_TYPE } from 'utils/constants/productEdit'
import addTestId from 'utils/lib/addTestId'

import styles from '../Products.module.scss'
import { usePlatformAccessPaywall } from 'features/platformAccess'

const Subscriptions = () => {
    const data = useSelector(ProductsModule.selectors.getSubscriptions)
    const loading = useSelector(ProductsModule.selectors.getProductsLoading)
    const { hasFeature } = useFeatureManager()
    const { openPlatformAccessPaywall, Paywall } =  usePlatformAccessPaywall()
    const hasSubscriptions = hasFeature(constants.PRODUCT_SUBSCRIPTIONS_FEATURE)
    return (
        <>
            <Paywall />
            <ContentSection.Child className={styles.child}>
                <section className={styles.productsHeader}>
                    <ContentSection.Header>Subscriptions</ContentSection.Header>
                    <Overflow
                        className={cx(styles.wrapper)}
                        header={
                            <Box.Flexbox.Container
                                alignItems="center"
                                justifyContent="between"
                            >
                                <div
                                    className={cx(styles.icon, 'icon-icon_add')}
                                />
                                <span>New subscription</span>
                            </Box.Flexbox.Container>
                        }
                        data-testid={addTestId('new-subscriptions-overflow')}
                    >
                        <Overflow.Option
                            onClick={() => hasSubscriptions ? Router.push('/products/edit/[type]/[id]', `/products/edit/${INDIVIDUAL_SUBSCRIPTION_TYPE}/new`, { shallow: true }) : openPlatformAccessPaywall(constants.PRODUCT_SUBSCRIPTIONS_FEATURE)}
                        >
                            <span className={cx(styles.icon, 'icon-contacts')}>
                                <span className={cx('path1')} />
                            </span>
                            Individual subscription
                        </Overflow.Option>
                        <AccessControl
                            requiredFeatures={[
                                constants.GADGET_ACCESS_FEATURE,
                                constants.WIDGET_FEATURE
                            ]}
                        >
                            <Overflow.Option
                                onClick={() => Router.push('/products/edit/[type]/[id]', `/products/edit/${GROUP_SUBSCRIPTION_TYPE}/new`, { shallow: true })}
                            >
                                <span className={cx(styles.icon, 'icon-contacts')}>
                                    <span className={cx('path1')} />
                                    <span className={cx('path2')} />
                                    <span className={cx('path3')} />
                                </span>
                                Group subscription
                            </Overflow.Option>
                        </AccessControl>
                    </Overflow>
                </section>
                <section className={styles.topBar}>
                    <ReactFinalForm
                        onSubmit={() => { }}
                        render={() =>
                            <Box.Flexbox.Container
                                alignItems="center"
                                justifyContent="start"
                                className={styles.subscription_filter}
                            >
                                <label>Show:</label>
                                <Field
                                    fieldProps={{
                                        className: styles.dropdown
                                    }}
                                    name="subscriptions_filter"
                                    component={Form.Dropdown}
                                    initialValue='all'
                                    options={[
                                        {
                                            value: 'all',
                                            label: 'All Subscriptions'
                                        },
                                        {
                                            value: 'subscription',
                                            label: 'Only individual subscriptions'
                                        },
                                        {
                                            value: 'group',
                                            label: 'Only group subscriptions'
                                        }
                                    ]}
                                />
                                <OnChange name="subscriptions_filter">
                                    {(value) => {
                                        this.setState({ filter: value })
                                    }}
                                </OnChange>
                            </Box.Flexbox.Container>
                        } />
                </section>
            </ContentSection.Child>
            <ContentSection.Child className={styles.child}>
                <SubscriptionsList items={data} loading={loading} />
            </ContentSection.Child>
        </>
    )
}

export default Subscriptions